import React from "react"
import { useSummerFunnel } from "./context/SummerFunnelContext"
import FunnelAppDownload from "../brevet/components/FunnelAppDownload"

const SummerAppDownloadScreen = () => {
    const { state } = useSummerFunnel()

    return (
        <FunnelAppDownload
            firstname={state.studentFirstname}
            trackingSource="summer_download_app"
            hideLogo
        />
    )
}

export default SummerAppDownloadScreen
